import { gql } from '@sixfold/app-data-framework';

export const USERS_TABLE_PAGE_SIZE = 30;

export const viewerCompany = gql`
  query ViewerCompany($companyId: String!) {
    viewer {
      user_id

      company(company_id: $companyId) {
        company_id
        company_name
        is_carrier
        is_shipper
        is_test
        arePlacesEnabled
        onboardingStatus: unifiedSignupStatus
        defaultVehicleDwellTimeThresholdMinutes

        isUIDisabled: featureFlag(flagName: "disable_customer_ui")
        isInvitationFlowDisabled: featureFlag(flagName: "disable_invitation_flow")
        isVisibilityControlCenterDisabled: featureFlag(flagName: "disable_visibility_control_center_carrier_tabs")
        isMapVehicleLocationsEnabled: featureFlag(flagName: "enable_map_vehicle_locations")
        isRoadUiDisabled: featureFlag(flagName: "disable_road_ui")
        isOceanMapViewEnabled: featureFlag(flagName: "enable_ocean_map_view")
        isEmailLoginEnabled: featureFlag(flagName: "enable_email_login")
        showNotesOnEveryTour: featureFlag(flagName: "show_notes_on_every_tour")
        isVehicleHistoryUiEnabled
        isFilesUploadEnabled: featureFlag(flagName: "enable_files_upload")
        isVisibilityReportingVisible
        isTrimbleVisibilityCustomer

        isStandalonePagesEnabled: featureFlag(flagName: "enable_standalone_pages")
        isOceanUIEnabled: featureFlag(flagName: "enable_ocean_ui")
        isAirUIEnabled: featureFlag(flagName: "enable_air_ui")
        isInlandVisibilityEnabled: featureFlag(flagName: "enable_inland_visibility")
        isOceanAnalyticsEnabled: featureFlag(flagName: "enable_ocean_analytics")
        isPolPodInTransportHeaderEnabled: featureFlag(flagName: "show_pol_pod_in_transport_header")
        isMaritimeIntelligenceEnabled: featureFlag(flagName: "enable_maritime_intelligence")

        roadToursCount
        oceanToursCount
        airToursCount

        isTableExportConfigEnabled: featureFlag(flagName: "enable_table_export_config")
        isOceanTransportExcelUploadEnabled: featureFlag(flagName: "enable_ocean_transport_excel_upload")
        isBulkTourUserAssignmentEnabled: featureFlag(flagName: "enable_bulk_tour_user_assignment")
        settings {
          allowAllocatingFromGlobalPool
          enableAutoAllocation
          enableAutoAllocationFullVisibility
        }
        me {
          profile {
            user_id
            first_name
            last_name
            email
          }

          role
          transporeonPlatform {
            userIdOnPlatform
          }

          configuration {
            vehicleDwellTimeThresholdMinutes
            isUserSessionInvalidationOnUiInactivityEnabled
          }
        }
      }
    }
  }
`;
export const viewerCompanies = gql`
  query ViewerCompanies {
    viewer {
      user_id

      companies {
        company_id
        company_name
        is_carrier
        is_shipper
        is_test
        onboardingStatus: unifiedSignupStatus
        isTrimbleVisibilityCustomer
      }
    }
  }
`;

export const companyUsers = gql`
  query CompanyUsers($companyId: String!, $first: Int, $cursor: String, $search: String) {
    viewer {
      user_id

      company(company_id: $companyId) {
        company_id
        is_shipper
        isPresentOnTransporeonPlatform

        users(search: $search) {
          users(first: $first, after: $cursor) {
            edges {
              node {
                profile {
                  user_id
                  first_name
                  last_name
                  email
                }

                role
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
          count
        }
      }
    }
  }
`;

export const removeUserFromCompany = gql`
  mutation RemoveUserFromCompany($input: RemoveUserFromCompanyInput!) {
    removeUserFromCompany(input: $input)
  }
`;

export const changeUserRoleInCompany = gql`
  mutation ChangeUserRoleInCompany($input: ChangeUserRoleInCompanyInput!) {
    changeUserRoleInCompany(input: $input) {
      profile {
        user_id
        first_name
        last_name
        email
      }

      role
    }
  }
`;

export const addUserToCompany = gql`
  mutation AddUserToCompany($input: AddUserToCompanyInput!) {
    addUserToCompany(input: $input) {
      profile {
        user_id
        first_name
        last_name
        email
      }

      role
    }
  }
`;

export const isPresentOnTransporeonPlatform = gql`
  query IsPresentOnTransporeonPlatform($companyId: String!) {
    viewer {
      user_id
      company(company_id: $companyId) {
        company_id
        isPresentOnTransporeonPlatform
      }
    }
  }
`;

export const updateUserInCompanyConfiguration = gql`
  mutation UpdateUserInCompanyConfiguration($input: UpdateUserInCompanyConfigurationInput!) {
    updateUserInCompanyConfiguration(input: $input) {
      profile {
        user_id
        first_name
        last_name
        email
      }

      role

      configuration {
        vehicleDwellTimeThresholdMinutes
      }
    }
  }
`;
